// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"19a46213","975":"4a5ca93d"}[chunkId] + ".chunk.js";
};